import React from 'react';
import PropTypes from 'prop-types';
import { find, get } from 'lodash';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from 'v5/design-system/DropdownMenu.js';
import { Button } from 'v5/design-system/Button.js';
import { cn } from 'v5/platform/dom/cn';
import { ArrowUpNarrowWide } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const SearchSorts = ({ orderBy, sorts, onSortChange }) => {
  const activeSort = find(sorts, s => s.field === get(orderBy, 'field'));
  const { t } = useTranslation(['v1_shared']);
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button size="sm" variant="secondary">
          <ArrowUpNarrowWide
            className={cn(
              'transition-all',
              get(orderBy, 'direction') === 'asc' ? 'rotate-180' : ''
            )}
          />
          {t('SearchSorts.sortBy')}{' '}
          {t(
            `SearchSorts.sorts.${get(activeSort, 'label')}`,
            get(activeSort, 'label')
          ) || ''}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start">
        {sorts.map((param, index) => (
          <DropdownMenuItem
            inset={get(orderBy, 'field') !== param.field}
            key={index}
            onSelect={() => onSortChange(param)}
          >
            {get(orderBy, 'field') === param.field ? (
              <ArrowUpNarrowWide
                className={cn(
                  'transition-all',
                  get(orderBy, 'direction') === 'asc' ? 'rotate-180' : ''
                )}
              />
            ) : null}
            {t(`SearchSorts.sorts.${get(param, 'label')}`)}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

SearchSorts.propTypes = {
  orderBy: PropTypes.object, // query.order_by
  sorts: PropTypes.array,
  onSortChange: PropTypes.func
};

export default SearchSorts;
